/*=========================================================================================
  File Name: favorites.js
  Description: Favorite Items Local Storage
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

function storeFavouriteItemsByRestaurantId (restaurantId, favorites) {
    // let id = JSON.parse(localStorage.getItem('currentRestaurant'));
    let storageId = 'Fav' + restaurantId;
    localStorage.setItem(storageId, JSON.stringify(favorites));
}

function getFavouriteItemsByRestaurantId(restaurantId) {
  // let id = JSON.parse(localStorage.getItem('currentRestaurant'));
  let storageId = 'Fav' + restaurantId;
  let favorites = localStorage.getItem(storageId);
  if (favorites == null) {
    return [];
  }
  return JSON.parse(favorites);
}

function clear(restaurantId) {
    let storageId = 'Fav' + restaurantId;
    localStorage.removeItem(storageId);
}

export default {
    storeFavouriteItemsByRestaurantId,
    getFavouriteItemsByRestaurantId,
    clear
}